type EmptyCartBagIllustrationProps = {
  brandLogoUrl?: string;
};

export default function EmptyCartBagIllustration({ brandLogoUrl }: EmptyCartBagIllustrationProps) {
  return (
    <div className="relative flex h-[100px] w-[120px] items-center justify-start overflow-visible">
      <svg
        className="h-full w-auto shrink-0"
        height="100"
        viewBox="0 0 164 100"
        preserveAspectRatio="xMinYMid meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path
          d="M92.299 99.195.54 79.005l97.231-24.251 65.853 10.682-46.997 21.002-13.914 3.439z"
          fill="url(#empty-cart-bag-shadow)"
        />
        <path d="M.494 78.993 24.99 6.612l64.546 10.106 1.81 80.564z" fill="url(#empty-cart-bag-front)" />
        <path
          stroke="url(#empty-cart-bag-edge)"
          strokeOpacity=".12"
          strokeWidth=".5"
          d="M.237 79.06 24.625 6.532"
        />
        <path d="m99.107 85.72-7.76 11.677V13.068h7.759l16.874 71.254z" fill="#fff" />
        <path
          d="m99.107 85.72-7.76 11.677V13.068h7.759l16.874 71.254z"
          fill="var(--flo-primary-button-color, #432A2E)"
          fillOpacity="0.2"
        />
        <path d="m99.106 85.72-7.759 11.677-1.776-80.844 1.776-3.485z" fill="#fff" />
        <path
          d="m99.106 85.72-7.759 11.677-1.776-80.844 1.776-3.485z"
          fill="var(--flo-primary-button-color, #432A2E)"
          fillOpacity="0.4"
        />
        <path
          d="M89.541 16.657 24.862 6.577l8.42-.775-1.877-1.997 67.526 9.272h-7.439z"
          fill="var(--flo-primary-button-color, #432A2E)"
        />
        <g opacity="0.2" filter="url(#empty-cart-bag-handle-shadow)">
          <path
            d="M42.56 15.768c0 20.128 6.548 22.729 15.409 22.729 7.512 0 9.837-11.423 10.923-17.226"
            stroke="var(--flo-primary-button-color, #432A2E)"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </g>
        <path
          d="M42.413 15.273c-2.048 7.022-1.873 22.031 9.362 22.968 11.236.936 15.605-11.167 17.117-16.97"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M42.413 15.273c-2.048 7.022-1.873 22.031 9.362 22.968 11.236.936 15.605-11.167 17.117-16.97"
          stroke="url(#empty-cart-bag-handle)"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="empty-cart-bag-shadow"
            x1="86.599"
            y1="85.294"
            x2="146.849"
            y2="68.382"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="var(--flo-primary-button-color, #432A2E)" />
            <stop offset="1" stopColor="var(--flo-primary-button-color, #432A2E)" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="empty-cart-bag-front"
            x1="26.085"
            y1="7.198"
            x2="48.912"
            y2="47.656"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#F5F5F5" stopOpacity="0.6" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="empty-cart-bag-edge"
            x1="25.336"
            y1="6.771"
            x2="12.668"
            y2="47.806"
            gradientUnits="userSpaceOnUse">
            <stop />
            <stop offset="1" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="empty-cart-bag-handle"
            x1="55.15"
            y1="15.273"
            x2="55.15"
            y2="38.292"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#554747" />
            <stop offset="1" stopColor="#232323" stopOpacity="0.4" />
          </linearGradient>
          <filter
            id="empty-cart-bag-handle-shadow"
            x="40.559"
            y="13.768"
            width="30.333"
            height="26.729"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_5765_20755" />
          </filter>
        </defs>
      </svg>

      <div className="absolute left-0 top-0 z-10 flex h-[100px] w-[88px] flex-col items-center justify-center pl-2 pt-10">
        {brandLogoUrl ? (
          <img
            src={brandLogoUrl}
            alt="Brand logo"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
            className="max-h-6 w-auto max-w-[56px] shrink-0 -translate-y-2 rotate-[10deg] object-contain"
          />
        ) : null}
      </div>
    </div>
  );
}
